import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import { useAuth } from "../hooks/AuthContext";
import { ButtonC } from "../components/simple";
import ModalC from "../components/modal";
import api from "../services/api";
import loadingBranco from "./../images/loadingBranco.gif";
import { toast } from "react-toastify";
import { Layout, Modal, Button, Spin, Typography, Space } from "antd";
import { Content } from "antd/es/layout/layout";
import Menu from "../components/Menu";
import Chat from "../components/Chat";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Sider } = Layout;
const { Title, Paragraph } = Typography;

const RouteFranqueados = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [statements, setStatements] = useState([]);

  const type = user.type;
  useEffect(() => {
    if (!type) {
      window.location.assign("/login");
    } else {
      if (type != "cliente") {
        if (type == "tecnico") {
          window.location.assign("/tecnico/home");
        } else {
          if (type == "atendente") {
            window.location.assign("/atendente/home");
          } else {
            if (type == "associado") {
              window.location.assign("/associado/home");
            } else {
              window.location.assign("/admin/home");
            }
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    loadStatements();
  }, []);

  async function loadStatements() {
    await api
      .get(`/statements-user`)
      .then((response) => {
        setStatements(response.data);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function confirmStatement(statement) {
    setIsLoading(true);
    await api
      .put(`/confirm-statement/${statement.id}`)
      .then(() => {
        setStatements(statements.filter((item) => item.id != statement.id));
        toast.success(
          "Confirmação de leitura do comunicado realizada com sucesso",
        );
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return type == "cliente" ? (
    <Layout style={{ minHeight: "100vh" }}>
      <Header sidebar={true} />
      <Layout>
        <Sider
          style={{
            background: "#008037",
            height: "100vh",
            position: "sticky",
            top: 0,
            left: 0,
            zIndex: 1000,
          }}
          width={230}
          trigger={null}
          collapsedWidth={0}
          breakpoint={"xl"}
        >
          <Menu />
        </Sider>
        <Content className="content">
          <Outlet />
          <Chat />
        </Content>
      </Layout>
      {statements.map((item) => (
        <Modal
          key={item.id}
          open={true}
          footer={null}
          closable={false}
          maskClosable={false}
          centered
          width={600}
          styles={{
            body: { padding: "40px 24px", textAlign: "center" }
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <InfoCircleOutlined style={{ fontSize: 48, color: "#1890ff", marginBottom: 20 }} />
            <Title level={3}>{item.title}</Title>
            <Paragraph
              style={{
                fontSize: 16,
                color: "#595959",
                marginTop: 10,
                marginBottom: 30,
                lineHeight: "1.6"
              }}
            >
              {item.description}
            </Paragraph>
            <Button
              type="primary"
              size="large"
              loading={isLoading}
              style={{ minWidth: 200, height: 45, fontSize: 16, borderRadius: 8 }}
              onClick={() => confirmStatement(item)}
            >
              Confirmar Leitura
            </Button>
          </div>
        </Modal>
      ))}
    </Layout>
  ) : (
    <></>
  );
};

export default RouteFranqueados;
